import { withInstall } from '@tav-ui/utils/with-install'
import FileActionUploadLink from './index.vue'

export * from './types'
export const TaFileActionUploadLink = withInstall(FileActionUploadLink)
export default TaFileActionUploadLink
